// extracted by mini-css-extract-plugin
export default {"layout":"PublicLayout_layout__kuV4k"};